import React, { Component, Fragment } from "react";
import {
  Card,
  Icon,
  Tag,
  Radio,
  Collapse,
  Checkbox,
  Row,
  Col,
  Input,
  Tooltip
} from "antd";
import F from "../../../Functions";
import WizardFooter from "./wizard-footer";
import UniversalWholeLife from "./images/new/universal.svg";
import Term from "./images/new/term.svg";
import Employer from "./images/new/employer.svg";
import Other from "./images/new/other.svg";
import { Translate } from "react-translated";
import axios from "axios";
import WizardPager from "../../../components/wizard-pager";
import SliderLayout from "./sliderlayout";

const RadioGroup = Radio.Group;
const { TextArea } = Input;
const Panel = Collapse.Panel;

class Step extends Component {
  state = {
    show_insurance_question: false,
    hasMortgageBroker: false
  };
  componentDidMount = () => {
    const { wizard } = this.props;
    let show_insurance_question = false;
    if (wizard.step_insurance_question !== null) {
      if (wizard.step_insurance_question === 3 && wizard.insurance_set === "primary_home") {
        show_insurance_question = true;
        this.props.updateField("step_insurance_question", 3);
      } else {
        if (wizard.home_mortgage_protection_toggle === "" || wizard.home_mortgage_protection_toggle === "0" ||
          wizard.home_mortgage_protection_toggle === null
        ) {
          show_insurance_question = true;
          this.props.updateField("step_insurance_question", 3);
        } else {
          show_insurance_question = false;
        }
      }
    } else {
      show_insurance_question = true;
      this.props.updateField("step_insurance_question", 3);
    }
    this.setState({ show_insurance_question });

    let hasMortgageBroker = false;

    const my_associations_API = this.props.isExternalBFile
      ? `/api/my_associations/external_rac?user_id=${this.props.userId}`
      : `/api/my_associations`;

    axios.get(my_associations_API).then((res) => {
      for (var x in res.data) {
        const agency_users = res.data[x];
        for (var i = 0; i < agency_users.length; i++) {
          if (agency_users[i].user_type === "MORTGAGE_BROKER") {
            hasMortgageBroker = true;
            break;
          }
        }
      }
      this.setState({ hasMortgageBroker });
    });


  };
  get_second_value = (str) => {
    if (typeof str !== "undefined" && str !== "" && str !== null) {
      str = str.replace(/\$/g, "");
      str = str.replace(/,/g, "");
      let arr = str.split("-");
      let num;
      if (arr.length > 1) {
        num = arr[1] * 1;
        return num;
      } else {
        arr = str.split("+");
        if (arr.length > 1) {
          num = arr[0] * 1;
          return num;
        }
      }
    }
    return 0;
  };
  render() {
    let { show_insurance_question } = this.state;
    const { wizard, updateField, handleBlur, updateRadioBtnToggle } = this.props;

    if (
      (wizard.home_mortgage_toggle === "1" ||
        wizard.secondary_home_mortgage_toggle === "1") &&
      show_insurance_question
    ) {
      show_insurance_question = true;
    } else {
      show_insurance_question = false;
    }

    let rangeValues = [
      "",
      "$1-$10,000",
      "$10,001-$25,000",
      "$25,001-$50,000",
      "$50,001-$100,000",
      "$100,001-$150,000",
      "$150,001-$200,000",
      "$200,001-$250,000",
      "$250,001-$300,000",
      "$300,001-$350,000",
      "$350,001-$400,000",
      "$400,001-$450,000",
      "$450,001-$500,000",
      "$500,001-$600,000",
      "$600,001-$700,000",
      "$700,001-$800,000",
      "$800,001-$900,000",
      "$900,001-$1,000,000"
    ];
    let v1, v2;
    for (let i = 1; i < 21; i++) {
      v2 = 1000000 + 100000 * i;
      v1 = v2 - 100000 + 1;
      rangeValues.push(F.dollar_format(v1) + "-" + F.dollar_format(v2));
    }
    rangeValues.push("$3,000,001-$4,000,000");
    rangeValues.push("$4,000,001-$5,000,000");

  //  let step = 500000;
  //   for (let i = 1; i <= 18; i++) {
  //     v2 = 1000000 + step * i;
  //     v1 = v2 - step + 1;
  //     rangeValues.push(F.dollar_format(v1) + "-" + F.dollar_format(v2));
  //   }

    let marks = {};
    for (let i = 0, rangeLen = rangeValues.length; i < rangeLen; i++) {
      marks[parseInt((i / (rangeLen - 1)) * 100, 10)] = {
        label:
          i === rangeValues.length - 1 ? rangeValues[i] : i === 0 ? "$0" : "",
        val: rangeValues[i]
      };
    }

    let mortgageRangeValues = [];
    let mortgageMarks = {};
    const home_market_value = this.get_second_value(wizard.home_market_value);
    for (let i = 0, rangeLen = rangeValues.length; i < rangeLen; i++) {
      let value = this.get_second_value(rangeValues[i]);
      if (home_market_value >= value) {
        mortgageRangeValues.push(rangeValues[i]);
      }
    }

    for (let i = 0, rangeLen = mortgageRangeValues.length; i < rangeLen; i++) {
      mortgageMarks[parseInt((i / (rangeLen - 1)) * 100, 10)] = {
        label:
          i === mortgageRangeValues.length - 1
            ? rangeValues[i]
            : i === 0
              ? "$0"
              : "",
        val: rangeValues[i]
      };
    }

    let home_mortgage_protection_policy_spouse = [];
    if (wizard.home_mortgage_protection_policy_spouse !== "") {
      home_mortgage_protection_policy_spouse = JSON.parse(
        wizard.home_mortgage_protection_policy_spouse
      );
    }

    let home_mortgage_protection_benefit_spouse = 0;
    if (wizard.home_mortgage_protection_benefit_spouse !== "") {
      for (let x in marks) {
        if (marks[x].val === wizard.home_mortgage_protection_benefit_spouse) {
          home_mortgage_protection_benefit_spouse = parseInt(x, 10);
        }
      }
    }

    let home_mortgage = 0;
    if (wizard.home_mortgage !== "") {
      for (let x in mortgageMarks) {
        if (mortgageMarks[x].val === wizard.home_mortgage) {
          home_mortgage = parseInt(x, 10);
        }
      }
    }

    let home_mortgage_protection_benefit = 0;
    if (wizard.home_mortgage_protection_benefit !== "") {
      for (let x in marks) {
        if (marks[x].val === wizard.home_mortgage_protection_benefit) {
          home_mortgage_protection_benefit = parseInt(x, 10);
        }
      }
    }

    let home_mortgage_protection_policy = [];
    if (wizard.home_mortgage_protection_policy !== "") {
      home_mortgage_protection_policy = JSON.parse(
        wizard.home_mortgage_protection_policy
      );
    }
    const home_mortgage_policy_type = [
      {
        name: "Universal/Whole-Life",
        icon: UniversalWholeLife,
        tip:
          "A life insurance policy that provides a death benefit that has the ability to be in-force for insured's lifetime. Usually has a policy cash value."
      },
      {
        name: "Term",
        icon: Term,
        tip:
          "A life insurance policy that provides a death benefit for a specific period of time. Usually 10,15, and 20 years."
      },
      {
        name: "Employer",
        icon: Employer,
        tip:
          "A life insurance policy that's provided by the employer to purchase with no medical requirements. Usually not enough to cover the insureds life insurance needs."
      },
      {
        name: "Other",
        icon: Other,
        tip:
          "Customer doesn't know what type of policy they have but knows they have a life policy."
      }
    ];

    return (
      <Fragment>
        <div className="stepBody">
          <Card className="insidecard">
            {this.state.hasMortgageBroker ? (
              <div style={{ marginBottom: 20 }}>
                {wizard.home_toggle !== "1" ? (
                  <Card className="insidecard stepcard">
                    <h5 className="headingText">
                      "Are you looking to purchase a new home within the next 12 months?"
                    </h5>

                    <RadioGroup className="radiogroup"
                      value={wizard.mortgage_purchase_home}
                      onChange={(e) =>
                        updateField("mortgage_purchase_home", e.target.value)
                      }
                      onBlur={(e) => {
                        if (!this.props.isExternalBFile) {
                          handleBlur("mortgage_purchase_home", e.target.value)
                        }
                      }
                      }
                    >
                      <Radio value={1}>
                        <Translate text={`Yes`} />
                      </Radio>
                      <Radio value={0}>
                        <Translate text={`No`} />
                      </Radio>
                    </RadioGroup>

                    {wizard.mortgage_purchase_home === 1 ? (<div style={{ marginTop: 20 }}>
                      <h5 className="headingText">
                        "Would you like one of our representatives to contact you and review your current mortgage?"
                      </h5>
                      <RadioGroup className="radiogroup"
                        value={wizard.mortgage_review}
                        onChange={(e) =>
                          updateField("mortgage_review", e.target.value)
                        }
                        onBlur={(e) => {
                          if (!this.props.isExternalBFile) {
                            handleBlur("mortgage_review", e.target.value)
                          }
                        }
                        }
                      >
                        <Radio value={1}>
                          <Translate text={`Yes`} />
                        </Radio>
                        <Radio value={0}>
                          <Translate text={`No`} />
                        </Radio>
                      </RadioGroup>
                    </div>) : null}


                  </Card>
                ) : null}
                {wizard.home_toggle === "1" ? (
                  <Card className="step3">
                    <h5 className="headingText">
                      "Do you have a mortgage and, if so, what is the mortgage balance?"
                    </h5>
                    {wizard.home_market_value !== "" &&
                      wizard.home_market_value !== null ? (
                      <div
                        style={{
                          width: "100%",
                          maxWidth: window.innerWidth > 768 ? "100%" : "400px",
                          margin: "0 auto",
                          padding: "10px",
                        }}
                      >
                        <SliderLayout
                          marks={mortgageMarks}
                          value={home_mortgage}
                          name="home_mortgage"
                          updateField={updateField}
                          updateRadioBtnToggle={updateRadioBtnToggle}
                        />
                      </div>
                    ) : null}
                    <div className={wizard.home_mortgage ? "sliderValue center-align silder-align" : "sliderValue silder-align"}
                    >
                      {wizard.home_mortgage || "No Mortgage"}
                    </div>


                    {wizard.home_mortgage !== null &&
                      wizard.home_mortgage !== "" ? (<div style={{ marginTop: 20 }}>
                        <h5 className="headingText">
                          "Have you had a mortgage review in the past 6-12 months?"
                        </h5>
                        <RadioGroup className="radiogroup"
                          value={wizard.had_mortgage_review}
                          onChange={(e) =>
                            updateField("had_mortgage_review", e.target.value)
                          }
                          onBlur={(e) => {
                            if (!this.props.isExternalBFile) {
                              handleBlur("had_mortgage_review", e.target.value)
                            }
                          }
                          }
                        >
                          <Radio value={1}>
                            <Translate text={`Yes`} />
                          </Radio>
                          <Radio value={0}>
                            <Translate text={`No`} />
                          </Radio>
                        </RadioGroup>
                      </div>
                    ) : null}

                    {wizard.home_mortgage !== null &&
                      wizard.home_mortgage !== "" ? (<div style={{ marginTop: 20 }}>
                        <h5 className="headingText">
                          "Are you looking to purchase a new home within the next 12 months?"
                        </h5>
                        <RadioGroup className="radiogroup"
                          value={wizard.mortgage_purchase_home}
                          onChange={(e) =>
                            updateField("mortgage_purchase_home", e.target.value)
                          }
                          onBlur={(e) => {
                            if (!this.props.isExternalBFile) {
                              handleBlur("mortgage_purchase_home", e.target.value)
                            }
                          }
                          }
                        >
                          <Radio value={1}>
                            <Translate text={`Yes`} />
                          </Radio>
                          <Radio value={0}>
                            <Translate text={`No`} />
                          </Radio>
                        </RadioGroup>
                      </div>
                    ) : null}

                    {wizard.home_mortgage !== null &&
                      wizard.home_mortgage !== "" ? (<div style={{ marginTop: 20 }}>
                        <h5 className="headingText">
                          "Would you like one of our representatives to contact you and review your current mortgage?"
                        </h5>
                        <RadioGroup className="radiogroup"
                          value={wizard.mortgage_review}
                          onChange={(e) =>
                            updateField("mortgage_review", e.target.value)
                          }
                          onBlur={(e) => {
                            if (!this.props.isExternalBFile) {
                              handleBlur("mortgage_review", e.target.value);
                            }
                          }
                          }
                        >
                          <Radio value={1}>
                            <Translate text={`Yes`} />
                          </Radio>
                          <Radio value={0}>
                            <Translate text={`No`} />
                          </Radio>
                        </RadioGroup>
                      </div>
                    ) : null}

                  </Card>
                ) : null}
              </div>
            ) : (
              <Card className="insidecard stepcard">
                <h5 className="headingText">"Do you have a mortgage and, if so, what is the mortgage balance?"</h5>
                {wizard.home_market_value !== "" &&
                  wizard.home_market_value !== null ? (

                  <div
                    style={{
                      width: "100%",
                      maxWidth: window.innerWidth > 768 ? "100%" : "400px",
                      margin: "0 auto",
                      padding: "10px",
                    }}
                  >
                    <SliderLayout
                      marks={mortgageMarks}
                      value={home_mortgage}
                      name="home_mortgage"
                      updateField={updateField}
                      updateRadioBtnToggle={updateRadioBtnToggle}
                    />
                  </div>
                ) : null}
                <div className={wizard.home_mortgage ? "sliderValue center-align silder-align" : "sliderValue silder-align"}
                >
                  {wizard.home_mortgage || "No Mortgage"}
                </div>
              </Card>
            )}
            {wizard.home_mortgage && show_insurance_question ? (
              <Card className="insidecard stepcard"
              >
                <h4 className="titleTextUnderline headingText">Life Insurance</h4>
                <h5 className="headingText">
                  "Is there life insurance or mortgage protection insurance to pay off the
                  remaining balance of the mortgage if something happened to you? If so,
                  what type of policy is it and what is the total death benefit payout value?" <span className='asteriskIcon'>*</span>
                </h5>
                <RadioGroup className="radiogroup"
                  value={wizard.life_insurance_toggle_1}
                  onChange={(e) => {
                    updateField("insurance_set",
                      "primary_home"
                    )
                    updateField(
                      "home_mortgage_protection_toggle",
                      e.target.value
                    )
                    updateField(
                      "life_insurance_toggle_1",
                      e.target.value
                    )
                    if (!this.props.isExternalBFile) {
                      updateRadioBtnToggle();
                    }
                  }
                  }


                >
                  <Radio value="1" >
                    <Translate text={`Yes`} />
                  </Radio>
                  <Radio value="0" >
                    <Translate text={`No`} />
                  </Radio>
                </RadioGroup>

                {wizard.home_mortgage_protection_toggle === "1" ? (
                  <div style={{ marginTop: 20 }}>
                    <h5 className="titleText2 headingText">Please Select Checklist: <span className='asteriskIcon'>*</span></h5>
                    <Checkbox.Group
                      className=""
                      value={home_mortgage_protection_policy}
                      style={{ width: "100%" }}
                      onChange={(checkedList) => {
                        updateField(
                          "home_mortgage_protection_policy",
                          JSON.stringify(checkedList)
                        )
                        if (!this.props.isExternalBFile) {
                          updateRadioBtnToggle();
                        }
                      }
                      }

                    >
                      <Row gutter={[16, 16]} style={{ display: 'flex', flexWrap: 'wrap' }}>
                        {home_mortgage_policy_type.map((item, i) => {
                          return (
                            <Col key={i}
                              xs={24}
                              sm={12}
                              md={8}
                              lg={6}
                              className="checkbox_layout">
                              <Tooltip placement="bottom" title={item.tip} getPopupContainer={() => document.body}>
                                <Checkbox value={item.name} style={{ width: "100%" }}>
                                  <div className="checkbox_items"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "10px",
                                    }}
                                  >
                                    <div className="icon"
                                      style={{ flexShrink: 0 }}>
                                      <img src={item.icon} alt={item.name} style={{
                                        objectFit: "contain",
                                      }} />
                                    </div>
                                    <div className="title" style={{ flexGrow: 1 }}>
                                      <Translate text={item.name} />
                                    </div>
                                  </div>
                                </Checkbox>
                              </Tooltip>
                            </Col>
                          );
                        })}
                      </Row>
                    </Checkbox.Group>


                    {wizard.home_mortgage_protection_policy && wizard.home_mortgage_protection_policy.length > 2 && (<div style={{ marginTop: 20 }}>
                      <h5 className="headingText">
                        "What is the total approximate benefit value ?" <span className='asteriskIcon'>*</span>
                      </h5>
                      <SliderLayout
                        marks={marks}
                        value={home_mortgage_protection_benefit}
                        updateField={updateField}
                        wizard={wizard}
                        updateRadioBtnToggle={updateRadioBtnToggle}
                        name='home_mortgage_protection_benefit'
                      />
                      <div className="sliderValue center-align silder-align">
                        {wizard.home_mortgage_protection_benefit || "$0"}
                      </div>
                    </div>)}

                    {wizard.spouse_first_name && (
                      <Collapse defaultActiveKey={["1"]} style={{ marginTop: 20 }}>
                        <Panel header={<Translate text={"Click to add spouse/partner info"} />}>
                          <div>
                            <h4 className="titleTextUnderline">
                              <Translate text={`Spouse's/Partner's Policy`} />
                            </h4>
                            <h5 className="titleText2 headingText">Please Select Checklist : </h5>
                            <Checkbox.Group
                              className=""
                              value={home_mortgage_protection_policy_spouse}
                              style={{ width: "100%" }}
                              onChange={(checkedList) => {
                                updateField(
                                  "home_mortgage_protection_policy_spouse",
                                  JSON.stringify(checkedList)
                                );
                                if (!this.props.isExternalBFile) {
                                  updateRadioBtnToggle();
                                }
                              }
                              }

                            >
                              <Row gutter={[20, 20]} style={{ display: 'flex', flexWrap: 'wrap', justifyContent: "space-evenly" }}>
                                {home_mortgage_policy_type.map((item, i) => {
                                  return (
                                    <Col key={i}
                                      xs={24}
                                      sm={12}
                                      md={8}
                                      lg={6} className="checkbox_layout">
                                      <Tooltip
                                        placement="bottom"
                                        title={item.tip}
                                        getPopupContainer={() => document.body}
                                      >
                                        <Checkbox value={item.name} style={{ width: "100%" }}>
                                          <div className="checkbox_items"
                                            // style={{ width: "14vw" }}
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "10px",
                                            }}
                                          >
                                            <div className="icon"
                                              style={{ flexShrink: 0 }}
                                            >
                                              <img
                                                src={item.icon}
                                                alt={item.name}
                                              />
                                            </div>
                                            <div className="title" style={{ flexGrow: 1 }}>
                                              <Translate text={item.name} />
                                            </div>
                                          </div>
                                        </Checkbox>
                                      </Tooltip>
                                    </Col>
                                  );
                                })}
                              </Row>
                            </Checkbox.Group>

                            {wizard.home_mortgage_protection_policy_spouse && wizard.home_mortgage_protection_policy_spouse.length > 2 && <div style={{ marginTop: 20 }}>
                              <h5 className="headingText">“What is the total approximate benefit value ?”</h5>
                              <SliderLayout
                                marks={marks}
                                value={home_mortgage_protection_benefit_spouse}
                                name="home_mortgage_protection_benefit_spouse"
                                updateField={updateField}
                                updateRadioBtnToggle={updateRadioBtnToggle}
                              />
                              <div className="sliderValue center-align silder-align">
                                {wizard.home_mortgage_protection_benefit_spouse ||
                                  "$0"}
                              </div>
                            </div>}
                          </div>
                        </Panel>
                      </Collapse>

                    )}
                  </div>
                ) : null}
              </Card>
            ) : null}

            <Row style={{ display: 'flex', justifyContent: 'center' }} className='center'>
              <Col span={18} className='didyouKnowSection'>
                {/* <img src={require("./images/didyouKnow.png")} width={120} className='imgdid' /> */}
                <img src={require('./images/didYouKnowBulb.jpg')} width={40} alt='' />
                <h4>Did You Know</h4>
                <p className="textContent">"The equity in your home may be at risk in the event of a liability lawsuit."</p>
              </Col>
            </Row>
            {/* <WizardFooter {...this.props} /> */}
          </Card>
        </div>
        <div className='stepFooter'>
          <WizardFooter {...this.props} />
        </div>
      </Fragment>
    );
  }
}

export default Step;



// WEBPACK FOOTER //
// ./src/scenes/Wizard/parts/step3_1_updated.js